import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

import { computed } from 'vue';
import { useAppTheme } from '@/composables/useAppTheme';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppThemeToggleBtn',
  setup(__props) {

const { isDark, toggleTheme } = useAppTheme();

const tooltip = computed(() =>
    isDark.value ? 'Светлая тема' : 'Тёмная тема',
);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
    class: "flex-shrink-0",
    icon: "",
    variant: "text",
    density: "comfortable",
    "aria-label": "Переключить тему оформления",
    onClick: _unref(toggleTheme)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_icon, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(isDark) ? 'mdi-weather-sunny' : 'mdi-weather-night'), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onClick"])), [
    [_directive_tooltip, { text: tooltip.value, eager: false }]
  ])
}
}

})